import {
	ORGANIZATIONS_GET,
	ORGANIZATIONS_ERROR,
	ORG_INFO_GET,
	ORG_INFO_ERROR,
	ORG_TIMEZONE_GET,
	WORKSPACES_GET,
	WORKSPACES_ERROR,
	MODULES_GET,
	MODULES_ERROR,
	CYCLES_GET,
	CYCLES_ERROR,
	ORG_FILTERS_SET
} from '../types';

import { resolve_org_timezone } from '../../utils/timezone_handler';

const initialState = {
	organizations: [],
	organization_info: {},
	// Timezone cache indexed by org id: { [org_id]: { timezone, is_fallback } }
	organization_timezones: {},
	workspaces: [],
	modules: [],
	cycles: [],
	route_cycle: null,
	org_filters: {},
	organization_errors: {}
}

export default function organizationReducer(state = initialState, action){
	switch(action.type){
		case ORGANIZATIONS_GET:
			return {
				...state,
				organizations: action.payload
			}
		case ORG_INFO_GET: {
			// The timezone cache is seeded here so the user organization never needs an extra request
			const org_info_id = action.payload?._id?.$oid;

			return {
				...state,
				organization_info: action.payload,
				organization_timezones: org_info_id
					? { ...state.organization_timezones, [org_info_id]: resolve_org_timezone(action.payload) }
					: state.organization_timezones
			}
		}
		case ORG_TIMEZONE_GET:
			return {
				...state,
				organization_timezones: {
					...state.organization_timezones,
					[action.payload.org_id]: {
						timezone: action.payload.timezone,
						is_fallback: action.payload.is_fallback
					}
				}
			}
		case WORKSPACES_GET:
			return {
				...state,
				workspaces: action.payload
			}
		case MODULES_GET:
			return {
				...state,
				modules: action.payload
			}
		case CYCLES_GET:
			return {
				...state,
				cycles: action.payload
			}
		case ORG_FILTERS_SET:
			return {
				...state,
				org_filters: action.payload
			}
		case ORGANIZATIONS_ERROR:
		case ORG_INFO_ERROR:
		case WORKSPACES_ERROR:
		case MODULES_ERROR:
		case CYCLES_ERROR:
			return {
				...state,
				organization_errors: {
					...state.organization_errors, 
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
